import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { Reservation, Service } from '@mews-commander/data-access';
import { getServiceOrder } from '@mews-commander/legacy-entities/src/ducks';
import { isProductServiceOrder } from '@mews-commander/legacy-entities/src/ducks/serviceOrderNew';
import { getCurrentEnterpriseReservation } from '@mews-commander/legacy-entities/src/selectors/reservations';
import {
    getProductServiceOrderAccountId,
    getServiceNames,
    getServiceOrderNoteText,
} from '../../../../../selectors/orderItems';

interface StateProps {
    names: Service['names'];
    serviceOrderNote?: string;
    accountId: string;
    linkedReservation?: Reservation;
}

interface OwnProps {
    serviceId: string;
    serviceOrderId: string;
}

export const connectProductOrderLabel = connect<StateProps, null, OwnProps, ApplicationState>(
    // @ts-expect-error
    createStructuredSelector({
        names: (state: ApplicationState, { serviceId }: OwnProps) => getServiceNames(state, { id: serviceId }),
        serviceOrderNote: getServiceOrderNoteText,
        accountId: (state: ApplicationState, { serviceOrderId }: OwnProps) =>
            getProductServiceOrderAccountId(state, { id: serviceOrderId }),
        linkedReservation: (state: ApplicationState, { serviceOrderId }: OwnProps) => {
            const serviceOrder = getServiceOrder(state, { id: serviceOrderId });
            const linkedReservationId =
                serviceOrder && isProductServiceOrder(serviceOrder) ? serviceOrder.data.value.linkedReservationId : '';

            const linkedReservationServiceOrder = getCurrentEnterpriseReservation(state, {
                id: linkedReservationId || '',
            });

            if (linkedReservationServiceOrder) {
                return linkedReservationServiceOrder;
            }
        },
    })
);
